/* ── Domain types for the Catalog listing + editors ───────────────── */

export interface PricingPlanTier {
  id: string;
  bookingTypeId: string;
  pricingPlanId: string;
  minCustomerCount: number;
  maxCustomerCount: number;
  createdAt: string;
}

export interface BookingTypeRecord {
  id: string;
  name: string;
  description: string | null;
  slug: string | null;
  isActive: boolean;
  sortOrder: number | null;
  state: string | null;
  customerCountType: string;
  minCustomers: number;
  maxCustomers: number;
  agreementType: string | null;
  agreementTypeId: string | null;
  createdAt: string;
  pricingPlans: PricingPlanTier[];
}

export interface PricingPlanRecord {
  id: string;
  name: string;
  authAmount: number;
  hourlyRate: number;
  createdAt: string;
}

/* ── Select options ──────────────────────────────────────────────── */

export const STATE_OPTIONS = [
  { value: "", label: "All states" },
  { value: "CA", label: "CA" },
  { value: "WI", label: "WI" },
] as const;

export const CUSTOMER_COUNT_TYPE_OPTIONS = [
  { value: "FIXED", label: "Fixed" },
  { value: "VARIABLE", label: "Client picks at booking" },
] as const;
